type JsonLeaf = string;
type JsonNode = JsonLeaf | { [key: string]: JsonNode };

function isPlainObject(value: unknown): value is Record<string, JsonNode> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function deepMergeResources<T extends Record<string, unknown>>(
  base: T,
  override: Partial<T> | undefined,
): T {
  if (!override) return { ...base };
  const out: Record<string, unknown> = { ...base };
  for (const key of Object.keys(override)) {
    const b = (base as Record<string, unknown>)[key];
    const o = (override as Record<string, unknown>)[key];
    if (isPlainObject(b) && isPlainObject(o)) {
      out[key] = deepMergeResources(b, o);
    } else {
      out[key] = o;
    }
  }
  return out as T;
}
